import {DiscountModel, ProductModel} from "../Models/ProductModel";
import {OrderProductModel} from "../Models/OrderModel";
import {useGetTva} from "./useGetTva";
import {useGetReductionFromQuantity} from "./useGetReductionFromQuantity";

export const useCreateOrderWithQuantityDiscount = (): (product: ProductModel, discount: DiscountModel, quantitee: number, otherOrderProducts: OrderProductModel[]) => OrderProductModel => {
    const getTva = useGetTva()
    const [getTotalMinusReduction, getReduction] = useGetReductionFromQuantity()

    const createOrder = (product: ProductModel, discount: DiscountModel, quantitee: number, otherOrderProducts: OrderProductModel[]): OrderProductModel => {
        const unitTva = getTva(product.priceTTC, product.product.tva?.rate)
        const unitPriceHT = product.priceTTC - unitTva
        return {
            name: product.product.name,
            privateName: product.product.privateName,
            nameCategory: product.product.productCategories[0]?.name,
            nameFamily: product.product.productCategories[0]?.productCategoryFamily?.name,
            quantity: quantitee,
            unitPriceHT: unitPriceHT,
            unitPriceTTC: product.priceTTC,
            unitDepositPriceTTC: product.depositPriceTTC,
            tvaRate: product.product.tva?.rate,
            discountName: discount.name,
            discountType: 'quantity',
            discountModel: discount,
            discount: getReduction(product.priceTTC * quantitee, product.priceTTC, quantitee, discount, otherOrderProducts),
            totalPriceHT: +(getTotalMinusReduction(unitPriceHT * quantitee, product.priceTTC, quantitee, discount, otherOrderProducts).toFixed(5)),
            totalPriceTTC: +(getTotalMinusReduction(product.priceTTC * quantitee, product.priceTTC, quantitee, discount, otherOrderProducts)).toFixed(2),
            totalDepositPriceTTC: product.depositPriceTTC * quantitee,
            totalTva: +(getTotalMinusReduction(unitTva * quantitee, product.priceTTC, quantitee, discount, otherOrderProducts)).toFixed(2),
            tvaCode: product.product.tva?.id,
            product: {
                id: product.product.id,
                image: product.product.image,
                categories: product.product.productCategories,
            }
        }
    }

    return (product: ProductModel, discount: DiscountModel, quantitee: number, otherOrderProducts: OrderProductModel[]): OrderProductModel => {
        const result = createOrder(product, discount, quantitee, otherOrderProducts)

        if (product.product.isMenu && product.eventPdvProducts?.length > 0) {
            result.eventPdvProducts = product.eventPdvProducts.map(extra => {
                const extraAsProduct: ProductModel = {
                    priceTTC: extra.priceTTC ?? 0,
                    depositPriceTTC: 0,
                    product: extra.product,
                    automaticDiscounts: [],
                    stockAvailable: 0,
                    eventPdvProducts: []
                }
                const orderProduct = createOrder(extraAsProduct, discount, quantitee, otherOrderProducts)
                orderProduct.productMenuName = product.product.name
                return orderProduct
            })
            const avgTvaRate = result.eventPdvProducts.reduce((sum, e) => sum + (e.tvaRate ?? 0), 0) / result.eventPdvProducts.length
            result.tvaRate = Math.round(avgTvaRate * 100) / 100
        }

        return result
    }
}
